import React from "react";
import GlobalStyles from "styles/GlobalStyles";
import { css } from "styled-components/macro"; //eslint-disable-line

import TermsOfServicePage from "pages/TermsOfService.js";

import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import SaaSProductLandingPage from "./demos/SaaSProductLandingPage";
import SEO from "./SEO";
import PrivacyPolicy from "./pages/PrivacyPolicy";

export default function App() {
  // If you want to disable the animation just use the disabled `prop` like below on your page's component
  // return <AnimationRevealPage disabled>xxxxxxxxxx</AnimationRevealPage>;

  return (
    <>
      <GlobalStyles />
      <Router>
        <Routes>
          <Route path="/" element={<SaaSProductLandingPage />} />
          <Route path="/terms-of-service" element={<TermsOfServicePage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        </Routes>
      </Router>
    </>
  );
}
